import CaireHead from '@/components/CaireHead';
import AppShell from '@/components/layouts/AppShell';
import ProviderSearchHome from '@/components/ProviderSearch/ProviderSearchHome';
import { PageWithLayout } from '@/types/AppWithLayout';

const ProviderSearchHomePage: PageWithLayout = () => {
  return (
    <>
      <CaireHead title="Provider Search" />
      <ProviderSearchHome />
    </>
  );
};

ProviderSearchHomePage.getLayout = (page) => {
  return (
    <AppShell
      withMenu={false}
      withNavigation={false}
      withLoginLink
      withAgentButton={false}
      closeHref="/">
      {page}
    </AppShell>
  );
};

export default ProviderSearchHomePage;
